import defaultTemplates from 'ui-article/axel-publication-content/js/templates';

const templates = defaultTemplates;

export default templates;
